import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const PoiEntertainmentIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="m7.575 1.576.838 6.923L9 8.432 8.108 1.05V1H1.89v.068L1 8.432l.588.067.837-6.923H3.52v4.61h-.592v1.152h4.143V6.187h-.59V1.576h1.094Zm-1.686 4.61H4.113v-4.61h1.776v4.61Z" />
        </SvgIcon>
    );
};
import React from "react";

import {SvgIcon} from "../../components/SvgIcon";
import {IIcon} from "../../types/IIcon";

export const PoiEntertainmentIcon = (props: IIcon) => {
    return (
        <SvgIcon {...props}>
            <path d="m7.575 1.576.838 6.923L9 8.432 8.108 1.05V1H1.89v.068L1 8.432l.588.067.837-6.923H3.52v4.61h-.592v1.152h4.143V6.187h-.59V1.576h1.094Zm-1.686 4.61H4.113v-4.61h1.776v4.61Z" />
        </SvgIcon>
    );
};
